/**
 * Globo Color Swatch: フィルター適用（Ajax）で商品グリッドが差し替わった後に
 * カラースウォッチを再表示するためのフック。
 *
 * 参照: Globo Docs "Smart Product Filter & Search"
 * https://docs.globo.io/app-integrations/smart-product-filter-and-search
 * → フィルター描画完了後に globoswatch.init() を呼ぶとスウォッチが再初期化される。
 */
(function () {
  // 商品詳細ページかどうか（多言語時は /id/products/ハンドル のようにロケールが先頭に付く）
  function isProductDetailPage() {
    return /\/products\/[^/]+/.test(window.location.pathname);
  }

  function tryGloboReinit() {
    if (isProductDetailPage()) return;
    // Globo 公式ドキュメント記載: globoswatch.init() でスウォッチを再初期化
    if (typeof window.globoswatch !== 'undefined' && typeof window.globoswatch.init === 'function') {
      window.globoswatch.init();
      return;
    }
    if (typeof window.gcws_reinit === 'function') {
      window.gcws_reinit();
      return;
    }
    if (typeof window.GloboColorSwatch !== 'undefined' && typeof window.GloboColorSwatch.init === 'function') {
      window.GloboColorSwatch.init();
      return;
    }
    document.dispatchEvent(new CustomEvent('globo:reload'));
    if (typeof window.jQuery !== 'undefined') {
      window.jQuery(document).trigger('globo:reload');
    }
  }

  function onProductGridUpdated() {
    if (isProductDetailPage()) return;
    setTimeout(tryGloboReinit, 100);
  }

  document.addEventListener('facet:updated', onProductGridUpdated);
  document.addEventListener('globo:product-grid-updated', onProductGridUpdated);

  // 初回表示: 遅延で再初期化。商品詳細ページでは実行しない。
  window.addEventListener('load', function () {
    if (!isProductDetailPage()) {
      setTimeout(tryGloboReinit, 100);
    }
  });
})();
